import { standardAction, errorAction } from "../common/actions";
import types from "./types";

const {
  VIDEO_PRODUCTS_REQUEST,
  VIDEO_PRODUCTS_SUCCESS,
  VIDEO_PRODUCTS_FAILURE,
  VIDEO_PRODUCTS_RESET,
} = types;

const doVideoProductsRequest = (payload) =>
  standardAction(VIDEO_PRODUCTS_REQUEST, payload);
const doVideoProductsSuccess = (payload) =>
  standardAction(VIDEO_PRODUCTS_SUCCESS, payload);
const doVideoProductsFailure = (payload) =>
  errorAction(VIDEO_PRODUCTS_FAILURE, payload);
const doVideoProductsReset = (payload) =>
  standardAction(VIDEO_PRODUCTS_RESET, payload);

export default {
  doVideoProductsRequest,
  doVideoProductsSuccess,
  doVideoProductsFailure,
  doVideoProductsReset,
};
